

import {
  ADD_COUPON_REQUEST,
  ADD_COUPON_SUCCESS,
  ADD_COUPON_FAILURE,
  FETCH_COUPONS_REQUEST,
  FETCH_COUPONS_SUCCESS,
  FETCH_COUPONS_FAILURE,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_FAILURE,
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAILURE,
} from '../actions/couponActions';

const initialState = {
  loading: false,
  coupons: [],
  error: '',
  status: 'idle',
  message: '',
};

const couponsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handle update, add, and fetch actions
    case UPDATE_COUPON_REQUEST:
      return { ...state, loading: true, status: 'loading' };
    case UPDATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: state.coupons.map((coupon) =>
          coupon._id === action.payload._id ? action.payload : coupon
        ),
        status: 'succeeded',
        message: 'Coupon updated successfully',
      };
    case UPDATE_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        status: 'failed',
        message: '',
      };

    case ADD_COUPON_REQUEST:
      return { ...state, loading: true, status: 'loading' };
    case ADD_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: [...state.coupons, action.payload],
        status: 'succeeded',
        message: 'Coupon added successfully',
      };
    case ADD_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        status: 'failed',
        message: '',
      };

    case FETCH_COUPONS_REQUEST:
      return { ...state, loading: true, status: 'loading' };
    case FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.payload,
        status: 'succeeded',
        message: 'Coupons fetched successfully',
      };
    case FETCH_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        status: 'failed',
        message: '',
      };

    // Handle delete action
    case DELETE_COUPON_REQUEST:
      return { ...state, loading: true, status: 'loading' };
    case DELETE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: state.coupons.filter((coupon) => coupon._id !== action.payload),
        status: 'succeeded',
        message: 'Coupon deleted successfully',
      };
    case DELETE_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        status: 'failed',
        message: '',
      };
    default:
      return state;
  }
};

export default couponsReducer;
